import { GET_EXTERNAL_DASHBOARD_COUNT_ERR, GET_EXTERNAL_DASHBOARD_COUNT } from '../../actionTypes/externalDashboardType'
import { getExternalDashboardCountApi} from 'api/Api';
import axios from "axios";
import { accessToken } from 'api/Token'
export const getExternalDashboardCount = payload => async dispatch => {
    try {
        ////console.log('payload',payload)
        let results = await axios.get(`${getExternalDashboardCountApi}/${payload}`, await accessToken())
        ////console.log("User Detail", results)
        let data = results && results.data
        dispatch({
            type: GET_EXTERNAL_DASHBOARD_COUNT,
            payload: data || {},
        });
    } catch (error) {   
        dispatch({
            type: GET_EXTERNAL_DASHBOARD_COUNT_ERR,
            payload: error && error.response
        });
    }
}


